/**
 * Dynamic API configuration
 */

/**
 * Get the API base URL dynamically based on the current location
 * @returns {string} The API base URL
 */
export const getApiBaseUrl = () => {
  // Allow override via environment variable for special cases
  if (process.env.REACT_APP_API_BASE_URL &&
      !process.env.REACT_APP_API_BASE_URL.includes('172.31') &&
      !process.env.REACT_APP_API_BASE_URL.includes('100.')) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  // Get current host and protocol
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;

  // Determine the API port based on environment
  const apiPort = process.env.REACT_APP_API_PORT || '8000';

  // Special case for development on localhost
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//${hostname}:${apiPort}/v1/`;
  }

  // Default: API on same host, different port
  return `${protocol}//${hostname}:${apiPort}/v1/`;
};

/**
 * Get the microservice host dynamically
 * @returns {string} The microservice host
 */
export const getMicroserviceHost = () => {
  // Allow override via environment variable for special cases
  if (process.env.REACT_APP_MICROSERVICE_HOST_PRIME &&
      !process.env.REACT_APP_MICROSERVICE_HOST_PRIME.includes('172.31') &&
      !process.env.REACT_APP_MICROSERVICE_HOST_PRIME.includes('100.')) {
    return process.env.REACT_APP_MICROSERVICE_HOST_PRIME;
  }

  // Get current hostname
  const hostname = window.location.hostname;
  const apiPort = process.env.REACT_APP_API_PORT || '8000';

  return `${hostname}:${apiPort}`;
};

/**
 * Get the redirect URI dynamically
 * @returns {string} The redirect URI for OAuth
 */
export const getRedirectUri = () => {
  // Allow override via environment variable for special cases
  if (process.env.REACT_APP_REDIRECT_URI &&
      !process.env.REACT_APP_REDIRECT_URI.includes('172.31') &&
      !process.env.REACT_APP_REDIRECT_URI.includes('100.')) {
    return process.env.REACT_APP_REDIRECT_URI;
  }

  // Use current location as redirect URI
  const protocol = window.location.protocol;
  const host = window.location.host; // includes port if present

  return `${protocol}//${host}/`;
};

/**
 * Check if we're in a development environment
 * @returns {boolean} True if in development mode
 */
export const isDevelopment = () => {
  return process.env.NODE_ENV === 'development' ||
         process.env.REACT_APP_BYPASS_AUTH === 'true' ||
         window.location.hostname === 'localhost' ||
         window.location.hostname === '127.0.0.1';
};

/**
 * Get WebSocket URL dynamically
 * @returns {string} The WebSocket URL
 */
export const getWebSocketUrl = () => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const apiPort = process.env.REACT_APP_API_PORT || '8000';

  return `${protocol}//${hostname}:${apiPort}/ws`;
};

export default {
  getApiBaseUrl,
  getMicroserviceHost,
  getRedirectUri,
  isDevelopment,
  getWebSocketUrl
};